import innovation from "../../../assets/innovate.png";
import reliability from "../../../assets/reliable.png";
import support from "../../../assets/support.png";

const Values = () => {
  return (
    <div className="px-6 lg:px-16 my-10">
      <div>
        <h1 className="font-semibold text-primaryBlack text-[32px] lg:text-[40px] lg:max-w-[400px] lg:leading-[54px] mb-7">
          Our values
        </h1>
        <div className="my-10 lg:grid grid-cols-3 gap-10 max-lg:space-y-7">
          <div className="bg-accent rounded-md p-10">
            <div className="flex items-center space-x-4 mb-6">
              <div>
                <img className="w-14 h-14" src={innovation} alt="" />
              </div>
              <div>
                <h1 className="font-semibold text-primaryBlack text-xl">
                  Innovation
                </h1>
              </div>
            </div>
            <div>
              <span className="text-lg text-paragraph">
                We believe in constantly pushing the boundaries and coming up
                with new and better ways to improve our delivery, logistics, and
                transportation solutions.
              </span>
            </div>
          </div>
          <div className="bg-themeYellow/20 rounded-md p-10">
            <div className="flex items-center space-x-4 mb-6">
              <div>
                <img className="w-14 h-14" src={reliability} alt="" />
              </div>
              <div>
                <h1 className="font-semibold text-primaryBlack text-xl">
                  Reliability
                </h1>
              </div>
            </div>
            <div>
              <span className="text-lg text-paragraph">
                We prioritize delivering on our promises and ensuring that our
                customers can depend on us to provide consistent and
                high-quality services.
              </span>
            </div>
          </div>
          <div className="bg-themeGreen/20 rounded-md p-10">
            <div className="flex items-center space-x-4 mb-6">
              <div className="w-14 h-14 p-4 bg-[#116B11]/20 rounded-full">
                <img className="" src={support} alt="" />
              </div>
              <div>
                <h1 className="font-semibold text-primaryBlack text-xl">
                  Customer-centricity
                </h1>
              </div>
            </div>
            <div>
              <span className="text-lg text-paragraph">
                We put our customers at the center of everything we do, striving
                to understand their needs and exceeding their expectations with
                our services.
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Values;
